// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JPUICMUHRoSKkna98IpR{flex-direction:column;height:100%;padding-top:9px;display:flex}.OgUO7Z6WL44vMzOKTvVv{margin:11px 16px 7px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `JPUICMUHRoSKkna98IpR`,
	"alert": `OgUO7Z6WL44vMzOKTvVv`
};
export default ___CSS_LOADER_EXPORT___;
